export default "__VITE_ASSET__NURwFbub__"